import BaseModelAPI from '../BaseModelAPI';

export default class DocumentTypeList extends BaseModelAPI {

	static entity = 'documenttypelist'
	static entityName = 'documenttype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
